import React from 'react';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MemberDataCaptureCurrentDefaultLayout
  from 'Components/ComponentLibrary/Organisms/MemberDataCapture/Layouts/MemberDataCaptureCurrentDefaultLayout';
import MemberDataCaptureCurrentActionItemLayout
  from 'Components/ComponentLibrary/Organisms/MemberDataCapture/Layouts/MemberDataCaptureCurrentActionItemLayout';
import { SelectInputLarge } from 'Packages/FacetDesign/Components/SelectInput';
import MemberDataCaptureCurrentAccountEditLayout
  from 'Components/ComponentLibrary/Organisms/MemberDataCapture/Layouts/MemberDataCaptureCurrentAccountEditLayout';
import ActionItemMetaOverride
  from 'Components/ComponentLibrary/Organisms/MemberDataCapture/Layouts/MetaOverride/ActionItemMetaOverride';
import DateOrYearPickerFacetDesign from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/facetDesign';
import MemberDataCaptureTaxReturnDocumentLayout from './Layouts/MemberDataCaptureTaxReturnDocumentLayout';

const metaOverrideSet = buildFacetDesignOverride()
  // fix design system components not taking up entire width
  .overrideAll({ _customProps: { fullWidth: true } })
  .nameOverride('desiredOutcomes', {
    _component: () => SelectInputLarge,
    _customProps: { fullWidth: true, multiple: true },
  }, overrideReadOnly)
  .override({ hint: 'yearMonth' }, {
    _customProps: {
      inputFormat: 'MM/YYYY',
    },
  }, overrideReadOnly)
  .nameOverride('plannedRetirementDate', {
    _component: () => DateOrYearPickerFacetDesign,
    _customProps: {
      inputFormat: 'MM/YYYY',
      startDateField: 'dateOfBirth',
      isAge: true,
    },
  }, overrideReadOnly);

export const ACTION_ITEM_TO_DO = 'MemberDataCaptureActionItemToDo';
export const TO_DO_ACTION_TRACKER = 'MemberDataCaptureToDoActionTracker';
export const CHECK_IN_WHAT_IF_ACTION = 'MemberDataCaptureCheckInWhatIfAction';
export const RECURRING_TRANSFER = 'MemberDataCaptureRecurringTransfer';
export const MEMBER_DATA_CAPTURE_ACCOUNT_EDIT = 'MemberDataCaptureAccountEdit';
export const MONTHLY_CHECK_IN_TO_DO_ITEM = 'MonthlyCheckInToDoItem';
export const MONTHLY_CHECK_IN_COMPLETION_ITEM = 'MonthlyCheckInCompletionItem';
export const TAX_RETURN_DOCUMENT = 'MemberDataCaptureTaxReturnDocument';

const MEMBER_DATA_CAPTURE_CURRENT_LAYOUT_MAP = {
  [ACTION_ITEM_TO_DO]: MemberDataCaptureCurrentActionItemLayout,
  [TO_DO_ACTION_TRACKER]: MemberDataCaptureCurrentActionItemLayout,
  [CHECK_IN_WHAT_IF_ACTION]: MemberDataCaptureCurrentActionItemLayout,
  [RECURRING_TRANSFER]: MemberDataCaptureCurrentActionItemLayout,
  [MEMBER_DATA_CAPTURE_ACCOUNT_EDIT]: MemberDataCaptureCurrentAccountEditLayout,
  [MONTHLY_CHECK_IN_TO_DO_ITEM]: MemberDataCaptureCurrentActionItemLayout,
  [MONTHLY_CHECK_IN_COMPLETION_ITEM]: MemberDataCaptureCurrentActionItemLayout,
  [TAX_RETURN_DOCUMENT]: MemberDataCaptureTaxReturnDocumentLayout,
};


const MEMBER_DATA_CAPTURE_META_OVERRIDE_MAP = {
  [ACTION_ITEM_TO_DO]: ActionItemMetaOverride,
  [TO_DO_ACTION_TRACKER]: ActionItemMetaOverride,
  [CHECK_IN_WHAT_IF_ACTION]: ActionItemMetaOverride,
  [RECURRING_TRANSFER]: ActionItemMetaOverride,
  [TAX_RETURN_DOCUMENT]: ActionItemMetaOverride,
};


export default function MemberDataCaptureCurrent({
  onSubmit, isInitializing, loadingError, collection, isReadOnly,
}) {
  const resource = collection?.resources().head();

  let MemberDataCaptureCurrentLayout = MEMBER_DATA_CAPTURE_CURRENT_LAYOUT_MAP[resource?.type()];
  let MemberDataCaptureMetaOverride = MEMBER_DATA_CAPTURE_META_OVERRIDE_MAP[resource?.type()];
  if (!MemberDataCaptureCurrentLayout) {
    MemberDataCaptureCurrentLayout = MemberDataCaptureCurrentDefaultLayout;
  }
  if (!MemberDataCaptureMetaOverride) {
    MemberDataCaptureMetaOverride = metaOverrideSet;
  }

  return (
    <DataContainer loading={isInitializing} loadingError={loadingError}>
      {resource && <MetaFormInline
        key={resource.id}
        metaOverrideSet={MemberDataCaptureMetaOverride}
        resource={resource}
        onSubmit={onSubmit}
        noIndividualSubmitButtons
        layout={MemberDataCaptureCurrentLayout}
        LayoutProps={{
          markCurrentAsComplete: onSubmit,
          collection,
          isReadOnly,
        }}
        hideEmptyFields={resource?.type() === 'UnknownMemberDataCapture'}
      />}
    </DataContainer>
  );
}
MemberDataCaptureCurrent.propTypes = {
  isInitializing: PropTypes.bool.isRequired,
  loadingError: PropTypes.object.isRequired,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};
